import styles from './useScrollBorder.module.scss';
import { useScrollDetection } from './useScrollDetection';
/**
 * Hook that combines scroll detection with border styling logic.
 * Automatically applies border and shadow styling when content is scrollable.
 * Returns both header and footer classNames.
 * For header: shows bottom border/shadow when can scroll to top (!isAtTop).
 * For footer: shows top border/shadow when not at bottom (scrolled up from bottom).
 */ export function useScrollBorder(options) {
    let dependencies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const { contentRef, enabled = true, headerBaseClassName, footerBaseClassName } = options;
    const { hasScroll, isAtBottom, isAtTop } = useScrollDetection(contentRef, dependencies, enabled);
    // For header: show when can scroll to top (!isAtTop)
    // For footer: show when not at bottom (!isAtBottom)
    const shouldShowHeaderBorder = hasScroll && !isAtTop;
    const shouldShowFooterBorder = hasScroll && !isAtBottom;
    function buildClass(base, active, show, baseClassName) {
        const result = show ? "".concat(base, " ").concat(active) : base;
        return baseClassName ? "".concat(baseClassName, " ").concat(result) : result;
    }
    return {
        headerClassName: buildClass(styles.scrollBorderHeader, styles.scrollBorderHeaderActive, shouldShowHeaderBorder, headerBaseClassName),
        footerClassName: buildClass(styles.scrollBorderFooter, styles.scrollBorderFooterActive, shouldShowFooterBorder, footerBaseClassName),
        hasScroll,
        isAtBottom,
        isAtTop
    };
}
